/** True for 1:1 chats, including type shapes like DIRECT_MESSAGE / direct / DM. */
export const isDirectMessageChannelType = (channel) => {
  if (!channel) return false;
  const raw = channel.type;
  const type = (
    typeof raw === 'string'
      ? raw
      : (raw && typeof raw === 'object' ? (raw.name || raw.type || '') : String(raw || ''))
  ).toString().toUpperCase();
  return type.includes('DIRECT') || type === 'DM';
};

export const isNotificationsChannel = (channel) =>
  channel?.type === 'NOTIFICATIONS'
  || channel?.systemChannelKey === 'NOTIFICATIONS'
  || (channel?.name || '').toLowerCase() === 'notifications';

export const isAttendanceChannelType = (channel) =>
  channel?.type === 'ATTENDANCE'
  || channel?.systemChannelKey === 'ATTENDANCE'
  || (channel?.name || '').toLowerCase() === 'attendance';

/** Attendance and Notifications are org features, not shown to Global org users. */
export const isHiddenForGlobalOrgUser = (channel, user) => {
  if (!user?.globalOrganization || !channel) return false;
  return isAttendanceChannelType(channel) || isNotificationsChannel(channel);
};

/** Hidden thread used for standalone task comments — not a real sidebar channel. */
export const isTaskCommentChannel = (channel) => {
  const key = String(channel?.systemChannelKey || '').trim();
  if (key.startsWith('TASK_THREAD:')) return true;
  return String(channel?.name || '').startsWith('Task comments ·');
};

export const isGroupWorkChannel = (channel) => {
  const type = String(channel?.type || '').toUpperCase();
  return type === 'PUBLIC' || type === 'PRIVATE';
};

export const userIsChannelMember = (channel, userId) => {
  if (!channel || !userId) return false;
  const ids = Array.isArray(channel.memberIds) ? channel.memberIds : [];
  return ids.some((id) => String(id) === String(userId));
};

/** Public/private channels are listed only for members, even when the channel is public. */
export const isVisibleSidebarChannel = (channel, user) => {
  if (!channel) return false;
  if (isHiddenForGlobalOrgUser(channel, user)) return false;
  if (isTaskCommentChannel(channel)) return false;
  if (!isGroupWorkChannel(channel)) return true;
  return userIsChannelMember(channel, user?.id);
};
